<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm"> 
  
            <lay-form-item label="类型" prop="type" mode="inline">
              <lay-select v-model="search.type">
                <lay-select-option value="0" label="全部"></lay-select-option>
                <lay-select-option value="1" label="信息审核"></lay-select-option>
                <lay-select-option value="2" label="订单问题"></lay-select-option>
                <lay-select-option value="3" label="商家咨询"></lay-select-option>
                <lay-select-option value="4" label="商务合作"></lay-select-option>
                <lay-select-option value="5" label="其他"></lay-select-option> 
              </lay-select>
            </lay-form-item>

             <lay-form-item label="状态" prop="state" mode="inline">
              <lay-select v-model="search.state">
                <lay-select-option value="0" label="全部"></lay-select-option>
                <lay-select-option value="1" label="未回复"></lay-select-option>
                <lay-select-option value="2" label="已回复"></lay-select-option> 
              </lay-select>
            </lay-form-item>
  
            <lay-form-item mode="inline">
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item>
  
          </lay-form>
          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">
 
  
            <template v-slot:imgs="{ row }">
                <div class="flex flex-wrap gap-2">
                    <img
                    v-for="(img, index) in row.imgs.split(',')"
                    :key="index"
                    :src="img"
                    @click="signleImg(img)"
                    style="width:62.9px;height:80px;cursor:pointer"
                    />
                </div>
                </template>

  
            <template #type="{ row }">
            <span v-if="row.type === 1">信息审核</span>
            <span v-else-if="row.type === 2">订单问题</span>
            <span v-else-if="row.type === 3">商家咨询</span>
            <span v-else-if="row.type === 4">商务合作</span>
            <span v-else>其他</span>
            </template>



          <template v-slot:operator="{ row }"> 
            <lay-button size="xs" type="danger" @click="deleteComplaint(row)">删除</lay-button>
             <lay-button size="xs" type="primary" @click="changeState(row)">回复</lay-button>
          </template>


          
          </lay-table>
   
        </lay-panel>
      </lay-col>
  
    </lay-row> 

    
  <lay-layer v-model="visible11" :shade="false" :area="['400px', '280px']" :btn="action11" title="回复">
    <div style="padding: 20px;">
      <lay-form :model="reply" ref="layFormRef11" >   
          <lay-textarea placeholder="请输入回复信息" v-model="reply"></lay-textarea> 
      </lay-form>
    </div>
  </lay-layer>

  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  
  import { allOpinion,replyOpinionMessage,delOpinion } from '../../api'
  
  
  
  
  const search = reactive({ 
    state: "0", 
    type: "0"
  })
  
  
  const loading = ref(false);
  
  const selectedKeys = ref([]);
  
  const dataSource = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([ 
    { title: "图片", key: "imgs", align: "center", customSlot: "imgs" },
    { title: "标题", key: "title", align: "center" },
    { title: "问题", key: "content", align: "center"},
    { title: "类型", key: "type", align: "center", customSlot: "type", width: "150px" },
    { title: "回复信息", key: "reply", align: "center" },
    { title: "账号", key: "userName", align: "center" }, 
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  
  const getAllOpinion = () => {
    loading.value = true;
    var data = { 
        page: page.current, 
        limit: page.limit,
        state: Number(search.state),
        type: Number(search.type)
        }

    allOpinion(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  
  getAllOpinion();
  
  const change = (page: any) => {
      getAllOpinion(); 
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
   
  //搜索
  const searchUser=()=>{
    page.current=1; 
      getAllOpinion();
  }
  
  
//删除
  const deleteComplaint=(row: any)=>{

    data = {"id": row.id};
    delOpinion(JSON.stringify(data) ).then((res: any) => { 
     if (res != "" && res.code == 0) {
       layer.msg("操作成功", { icon : 1, time: 1000});
         getAllOpinion();


     } else {
       layer.msg(res.msg, { icon : 2, time: 1000})
     }
   })
  }


 
var data:any;

const changeState = (row: any) => {
     data = {"id": row.id }; 
    visible11.value = !visible11.value;  
}


//回复信息
const addReviewComplaint=(data:any)=>{

  replyOpinionMessage(data).then((res: any) => {
     
    if (res != "" && res.code == 0) { 
      layer.msg("操作成功", { icon : 1, time: 1000})
        getAllOpinion(); 
    } else {
      layer.msg(res.msg, { icon : 2, time: 1000})
    }
  })

}


const reply =ref("");

const visible11 = ref(false);

const action11 = ref([
    {
        text: "确认",
        callback: () => { 
          data.key=reply.value; 
          addReviewComplaint(JSON.stringify(data));
          visible11.value = !visible11.value;
        }
    },
    {
        text: "取消",
        callback: () => {
          visible11.value = !visible11.value;
        }
    }
])
   
  
  </script>
  
 